import axios from "axios";

type Property = {
    id: string;
    listingType: string;
    state: string;
}

export const getPropertiesForConcierge = async (properties: Property[]) => {
    // Get all unique (listingType, state) pairs
    const uniquePairs = Array.from(
        new Set(properties.map((doc) => `${doc.listingType}|||${doc.state}`))
    ).map((pair) => {
        const [listingType, state] = pair.split('|||');
        return { listingType, state };
    });

    try {
        // Fetch properties for each unique (listingType, state) pair
        const allProperties = await Promise.all(uniquePairs.map(async ({ listingType, state }) => {
            const matchingProperties = properties.filter(
                (doc) => doc.listingType === listingType && doc.state === state
            );
            console.log(
                "Fetching properties for listing type and state:",
                listingType,
                state,
                matchingProperties.map((doc) => doc.id)
            );
            const payload = {
                compareIds: matchingProperties.map((doc) => doc.id),
                listingType,
                state,
            };
            const listings: any = await fetchPropertiesForConcierge(payload);
            return listings.properties;
        }));

        const flatProperties = allProperties.flat();
        return flatProperties;
        
    } catch (error) {
        throw Error("Error fetching properties for concierge from DB: " + error);
    }
}

interface FetchPropertiesForConciergeParams {
    compareIds: string[];
    listingType: string;
    state: string;
  }
  
const fetchPropertiesForConcierge = async (
    params: FetchPropertiesForConciergeParams
  ) => {
    const authStore = useAuthStore();
  
    if (!authStore) {
      throw new Error("User not authenticated");
    }
  
    const AuthState = await authStore.getAuthState();
    const personaId = authStore.getuid;
    const personaStore = usePersonaStore();
    const persona = await personaStore.getPersona(personaId);
    const neightbourhoodStore = useNeightbourhoodStore();
  
    if (personaStore.form?.movingTo?.detailed_address) {
      await neightbourhoodStore.setcitystatecounty(
        personaStore.form.movingTo.detailed_address
      );
    }
  
    if (!params.compareIds || params.compareIds.length === 0) {
      return [];
    }
  
    console.log("Fetching properties for comparison2:", params);
  
    try {
      const { data } = await axios.post("/api/properties/compare", {
        state: params.state,
        propertyIds: params.compareIds,
        listingType: params.listingType,
      });
      if (data.success) {
        return {
          properties: data.properties,
          metadata: data.metadata,
        };
      } else {
        throw new Error(data.message || "Failed to fetch properties");
      }
    } catch (error) {
      console.error("❌ Error in Fetch Properties For Comparison:", error);
      throw error;
    }
  };